import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Sortable } from '@shopify/draggable';
import PlaceAnimation from './plugins/place-animation.js';

const DRAGGABLE_DEFAULTS = {
  containers: '[pendo-draggable-container]',
  item: '[pendo-draggable-item]',
  handle: '[pendo-draggable-handle]',
  mirror: {
    constrainDimensions: true
  },
  placeAnimation: {
    easingFunction: 'ease-in-out'
  },
  classes: {
    'mirror': 'pendo-draggable-mirror',
    'body:dragging': 'pendo-draggable--is-dragging',
    'draggable:over': 'pendo-draggable--over',
    'container:dragging': 'pendo-draggable-container--is-dragging',
    'container:over': 'pendo-draggable-container--over',
    'container:placed': 'pendo-draggable-container--placed',
    'source:dragging': 'pendo-draggable-source--is-dragging',
    'source:original': 'pendo-draggable--original',
    'source:placed': 'pendo-draggable-source--placed'
  }
};
function getOptions(el, options) {
  return _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
    classes: _objectSpread2(_objectSpread2({}, PendoDraggable.options.classes), options.classes),
    draggable: options.item || PendoDraggable.options.item
  }, options.handle && {
    handle: options.handle
  }), el.querySelectorAll(PendoDraggable.options.handle).length && {
    handle: PendoDraggable.options.handle
  }), {}, {
    containers: PendoDraggable.options.containers || options.containers,
    mirror: _objectSpread2(_objectSpread2({}, PendoDraggable.options.mirror), options.mirror)
  }, options.plugins && {
    plugins: options.plugins
  }), {}, {
    disabled: options.disabled
  });
}
function getDraggableStatus(el, draggable) {
  const hasActiveContainers = !!el.querySelectorAll('[pendo-draggable-container]').length;
  const hasActiveItems = !!el.querySelectorAll('[pendo-draggable-item]').length;
  const hasActiveHandles = !!el.querySelectorAll('[pendo-draggable-handle]').length;
  if (draggable.containers.length === 1) {
    if (draggable.options.handle) {
      return hasActiveItems && hasActiveHandles;
    }
    return hasActiveItems;
  }
  if (draggable.options.handle) {
    return hasActiveContainers && hasActiveItems && hasActiveHandles;
  }
  return hasActiveContainers && hasActiveItems;
}
function shouldCancelDrag(element) {
  let currentElem = element;
  let isParent = false;
  while (currentElem) {
    const hasAttribute = currentElem.hasAttribute('pendo-draggable-ignore');
    if (hasAttribute) {
      isParent = true;
      currentElem = undefined;
    } else {
      currentElem = currentElem.parentElement;
    }
  }
  return isParent;
}
function registerEventListeners(draggable) {
  let {
    events
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!events) {
    return;
  }
  if (Object.keys(events)) {
    Object.entries(events).forEach(_ref => {
      let [event, fn] = _ref;
      draggable.on(event, fn);
    });
  }
}
function createDraggable(el, _ref2) {
  let {
    value
  } = _ref2;
  const options = _objectSpread2(_objectSpread2({}, getOptions(el, _objectSpread2({}, value))), {}, {
    plugins: [PlaceAnimation]
  });
  let containers = el.querySelectorAll(options.containers);
  if (containers.length === 0) {
    containers = el;
  }
  const hasIgnoredSelectors = !!el.querySelectorAll('[pendo-draggable-ignore]').length;
  const draggable = new Sortable(containers, _objectSpread2(_objectSpread2({}, options), {}, {
    hasIgnoredSelectors
  }));
  return draggable;
}
function inserted(el, binding, vnode) {
  if (binding.value === false) {
    return;
  }
  const draggable = createDraggable(el, binding);
  el.classList.add('pendo-draggable');
  if (draggable.options.handle) {
    el.classList.add('has-draggable-handles');
  } else {
    el.classList.add('has-draggable-items');
  }
  el.classList.toggle('is-draggable', getDraggableStatus(el, draggable));
  registerEventListeners(draggable, binding.value);
  draggable.on('drag:start', event => {
    const isDraggable = getDraggableStatus(el, draggable);
    if (draggable.disabled || !isDraggable) {
      event.cancel();
      return;
    }
    const ignoredSelectors = !!el.querySelectorAll('[pendo-draggable-ignore]').length;
    if (!ignoredSelectors) {
      return;
    }
    const {
      target
    } = event.originalEvent;
    const cancelDragEvent = shouldCancelDrag(target);
    if (cancelDragEvent) {
      event.cancel();
    }
  });
  const vm = vnode.context;
  if (!vm.PendoDraggable) {
    vm.PendoDraggable = draggable;
  }
}
function componentUpdated(el, binding, vnode) {
  if (binding.value === false) {
    return;
  }
  const {
    PendoDraggable
  } = vnode.context;
  el.classList.toggle('is-draggable', getDraggableStatus(el, PendoDraggable));
}
function unbind(el, binding, vnode) {
  if (vnode.context.PendoDraggable) {
    vnode.context.PendoDraggable.destroy();
    delete vnode.context.PendoDraggable;
  }
}
const PendoDraggable = {
  options: DRAGGABLE_DEFAULTS,
  inserted,
  componentUpdated,
  unbind
};
var PendoDraggable$1 = PendoDraggable;

export { DRAGGABLE_DEFAULTS, PendoDraggable, componentUpdated, createDraggable, PendoDraggable$1 as default, getDraggableStatus, getOptions, inserted, registerEventListeners, shouldCancelDrag, unbind };
//# sourceMappingURL=pendo-draggable.js.map
